"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FineTuningResponseModelStateValue = void 0;
exports.FineTuningResponseModelStateValue = {
    NotStarted: "not_started",
    Queued: "queued",
    FineTuning: "fine_tuning",
    FineTuned: "fine_tuned",
    Failed: "failed",
    Delayed: "delayed",
};
